export function useSharePageUtils() {
  function checkIfPastDate(date) {
    if (!date) return false;

    try {
      const auxDate = new Date(date);
      const today = new Date(Date.now());
      return auxDate < today;
    } catch (err) {
      console.log('useSharePageUtils checkIfPastDate', err);
    }
  }

  return { checkIfPastDate };
}
